import { Injectable } from '@angular/core';

import { StatsigService } from '@services/statsig.service';

// define an enum if feature gate key is used anywhere else in the app
export enum AM_FEATURE_FLAGS {
  FE_AG_DOOR_SENSOR_ENABLED = 'fe-ag-door-sensor-enabled',
  FE_AG_DOOR_SENSOR_ALERT_ENABLED = 'fe-ag-door-sensor-alert-enabled',
  FE_AG_TELEMATICS_CHANGES_ENABLED = 'fe-ag-telematics-changes-enabled',
  FE_AG_ASSET_PROFILE_CHANGES_ENABLED = 'fe-ag-asset-profile-changes-enabled',
  FE_AG_CABLE_DISCONNECT_ALERT_ENABLED = 'fe-ag-cable-disconnect-alert-enabled',
  FE_AG_REEFER_THERMOKING_POST_GA_ENABLED = 'fe-ag-reefer-thermoking-post-ga-enabled',
  FE_AG_LOW_ASSET_INVENTORY_ALERT_ENABLED = 'fe-ag-low-asset-inventory-alert-enabled',
  FE_AG_ASSET_PROFILE_INSPECTION_REPORT_ENABLED = 'fe-ag-asset-profile-inspection-report-enabled',
  INSTALLER_ROLE_PERMISSON_ENABLED = 'installer-role-permission-enabled',
  FLEET_AG_TRAILER_TRACTOR_API_PAIRING_ENABLED = 'fleet-ag-trailer-tractor-api-pairing-enabled',
  AG_WIFI_HOTSPOT_REPORT_CHANGES_ENABLED = 'ag-wifi-hotspot-report-changes-enabled',
  AG_WIFI_HOTSPOT_THROTTLING_ENABLED = 'ag-wifi-hotspot-throttling-enabled',
  FE_AG_AG31_ADDITIONAL_CHECKINS_ENABLED = 'fe-ag-ag31-additional-checkins-enabled',
  FE_AG_AG31_LOW_BATTERY_CHANGES_ENABLED = 'fe-ag-ag31-low-battery-changes-enabled',
  FE_AG_WIFI_ALERT_CHANGES_ENABLED = 'fe-ag-wifi-alert-changes-enabled',
  FE_AG_RECALL_LOCATION_ENABLED = 'fe-ag-recall-location-enabled',
  FE_AG_55_LOW_BATTERY_CHANGES_ENABLED = 'fe-ag-ag55-low-battery-changes-enabled',
  FE_AG_ASSET_IDLING_ENABLED = 'fe-ag-asset-idling-enabled',
  FE_AG_CARRIER_INTEGRATION_PHASE_1_ENABLED = 'fe-ag-carrier-integration-phase-1-enabled',
  FE_AG_CARRIER_INTEGRATION_PHASE_2_ENABLED = 'fe-ag-carrier-integration-phase-2-enabled',
  FE_AG_OMNICAM_ENABLED = 'fe-ag-omnicam-enabled',
  FE_AG_AG_31_SENSOR_ASSIGNMENT_ENABLED = 'fe-ag-31-sensor-assignment-enabled',
  TYPE_AHEAD_DORMANCY_REPORT = 'equipment-monitoring-dormancy-report',
  TYPE_AHEAD_ASSET_ENGINE_HOURS_REPORT = 'equipment-monitoring-asset-engine-hours-report',
  TYPE_AHEAD_ASSET_UTILIZATION_SUMMARY_REPORT = 'equipment-monitoring-asset-utilization-summary-report',
  FE_EM_CARRIER_ALARMS_EVENT_ENABLED = 'fe-em-carrier-alarms-alert-enabled',
  FE_AG_DOOR_OPEN_ALERT_ENABLED = 'fe-ag-door-open-alert-enabled',
  FE_EM_GEOFENCES_LIST_VIEW_ENABLED = 'fe-em-geofences-list-view-enabled',
  FE_EM_GEOFENCE_LIVE_VIEW_ENABLED = 'fe-em-geofence-live-view-enabled',
  FE_EM_ARE_OEM_ENTITIES_IN_ALERTS_ENABLED = 'fe-ag-oem-entities-in-alerts-enabled',
  FE_EM_IS_LOCATED_AT_ASSETS_LISTING_ICON_ENABLED = 'fe-em-is-located-at-assets-listing-icon-enabled',
  FE_AG_ADDITIONAL_PING_CHECK_IN_UPDATE_ENABLED = 'fleet-ag-additional-ping-frequency',
  FE_EM_IS_PTO_ENABLED = 'fe-em-is-pto-enabled',
}

@Injectable({ providedIn: 'root' })
export class AssetMonitoringFeatureFlagService {

  constructor(private statsigService: StatsigService) { }

  public isFEEMPTOEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_EM_IS_PTO_ENABLED);
  }

  public isFEAdditionalPingCheckInUpdateEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_ADDITIONAL_PING_CHECK_IN_UPDATE_ENABLED);
  }

  public isFEEMOemEntitiesInAlertsAreEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_EM_ARE_OEM_ENTITIES_IN_ALERTS_ENABLED);
  }

  public isFEEMGeofencesListViewEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_EM_GEOFENCES_LIST_VIEW_ENABLED);
  }

  public isFEEMGeofenceLiveViewEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_EM_GEOFENCE_LIVE_VIEW_ENABLED);
  }

  public isFEEMCarrierAlarmsAlertEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_EM_CARRIER_ALARMS_EVENT_ENABLED);
  }

  public isFEAGDoorOpenAlertEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_DOOR_OPEN_ALERT_ENABLED);
  }

  public isAssetGateway31SensorAssignmentEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_AG_31_SENSOR_ASSIGNMENT_ENABLED);
  }

  public isAssetGatewayOmnicamEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_OMNICAM_ENABLED);
  }

  public isAGAssetGateway55LowBatteryChangesEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_55_LOW_BATTERY_CHANGES_ENABLED);
  }

  public isAGWifiHotspotAlertChangesEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_WIFI_ALERT_CHANGES_ENABLED);
  }

  public isAG31AdditionalCheckInsEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_AG31_ADDITIONAL_CHECKINS_ENABLED);
  }

  public isAGAssetGateway31LowBatteryChangesEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_AG31_LOW_BATTERY_CHANGES_ENABLED);
  }

  public isAGAssetProfileInspectionReportEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_ASSET_PROFILE_INSPECTION_REPORT_ENABLED);
  }

  public isAGTelematicsChangesEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_TELEMATICS_CHANGES_ENABLED);
  }

  public isAGAssetProfileChangesEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_ASSET_PROFILE_CHANGES_ENABLED);
  }

  public isAGDoorSensorEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_DOOR_SENSOR_ENABLED);
  }

  public isAGDoorSensorAlertEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_DOOR_SENSOR_ALERT_ENABLED);
  }

  public isAGReeferThermokingPostGAEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_REEFER_THERMOKING_POST_GA_ENABLED);
  }

  public isAGCableDisconnectAlertEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_CABLE_DISCONNECT_ALERT_ENABLED);
  }

  public isLowAssetInventoryAlertEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_LOW_ASSET_INVENTORY_ALERT_ENABLED);
  }

  public isInstallerRolePermissionEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.INSTALLER_ROLE_PERMISSON_ENABLED);
  }

  public isAGWifiHotspotReportChangesEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.AG_WIFI_HOTSPOT_REPORT_CHANGES_ENABLED);
  }

  public isAGWifiHotspotThrottlingEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.AG_WIFI_HOTSPOT_THROTTLING_ENABLED);
  }

  public isFleetAgTrailerTratorApiPairingEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FLEET_AG_TRAILER_TRACTOR_API_PAIRING_ENABLED);
  }

  public isAGRecallLocationEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_RECALL_LOCATION_ENABLED);
  }

  public isAGAssetIdlingEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_ASSET_IDLING_ENABLED);
  }

  public isAGCarrierIntegrationPhase1Enabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_CARRIER_INTEGRATION_PHASE_1_ENABLED);
  }

  public isAGCarrierIntegrationPhase2Enabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_AG_CARRIER_INTEGRATION_PHASE_2_ENABLED);
  }

  public isFEEMAssetsListingViewIconEnabled(): boolean {
    return this.statsigService.evaluateGate(AM_FEATURE_FLAGS.FE_EM_IS_LOCATED_AT_ASSETS_LISTING_ICON_ENABLED);
  }
}
